"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var template = require('./dock.jsx');

var displayNames = require('../displayNames');

var DockDirection = require('./dockDirection');

var DIRECTIONS = {
  TOP_LEFT: 'TOP_LEFT',
  TOP: 'TOP',
  TOP_RIGHT: 'TOP_RIGHT',
  LEFT: 'LEFT',
  MIDDLE: 'MIDDLE',
  RIGHT: 'RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM: 'BOTTOM',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
};
var types = Object.keys(DIRECTIONS);
var DOCK_DIRECTIONS_PROPS = [{
  className: 'top left',
  value: DIRECTIONS.TOP_LEFT
}, {
  className: 'top',
  value: DIRECTIONS.TOP
}, {
  className: 'top right',
  value: DIRECTIONS.TOP_RIGHT
}, {
  className: 'left',
  value: DIRECTIONS.LEFT
}, {
  className: 'middle',
  value: DIRECTIONS.MIDDLE
}, {
  className: 'right',
  value: DIRECTIONS.RIGHT
}, {
  className: 'bottom left',
  value: DIRECTIONS.BOTTOM_LEFT
}, {
  className: 'bottom',
  value: DIRECTIONS.BOTTOM
}, {
  className: 'bottom right',
  value: DIRECTIONS.BOTTOM_RIGHT
}];

var generateDockDirections = function generateDockDirections(props) {
  return _.map(DOCK_DIRECTIONS_PROPS, function (itemProps, index) {
    return React.createElement(DockDirection, {
      className: itemProps.className,
      value: itemProps.value,
      disabled: props.disabled || _.includes(props.disabledDirections, itemProps.value),
      onMouseEnter: props.onDirectionMouseEnter,
      onMouseLeave: props.onDirectionMouseLeave,
      key: "dockDirection".concat(index)
    });
  });
};

var Dock = /*#__PURE__*/function (_React$Component) {
  _inherits(Dock, _React$Component);

  var _super = _createSuper(Dock);

  function Dock(props) {
    var _this;

    _classCallCheck(this, Dock);

    _this = _super.call(this, props);

    _this.generateDockDirections = function () {
      return generateDockDirections(props);
    };

    return _this;
  }

  _createClass(Dock, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return Dock;
}(React.Component);

Dock.displayName = displayNames.DOCK;
Dock.propTypes = {
  /** Callback function `(direction) => {}`, triggered when the user clicks on a direction */
  onChange: PropTypes.func.isRequired,

  /** The selected direction value */
  value: PropTypes.oneOf(types),

  /** Callback function `(direction) => {}`, triggered when the user hovers over a direction */
  onDirectionMouseEnter: PropTypes.func,

  /** Callback function `(direction) => {}`, triggered when the user moves the cursor so that it is no longer contained within a direction */
  onDirectionMouseLeave: PropTypes.func,

  /** List of disabled directions that are blocked from being selected. */
  disabledDirections: PropTypes.arrayOf(PropTypes.oneOf(types)),

  /** Indicates weather the control should be disabled or not */
  disabled: PropTypes.bool
};
Dock.defaultProps = {
  disabled: false
};
module.exports = compose(Dock);